import api from "@/api"

const state = {
  voucherList: [],
  voucherDetail: {}
}

const actions = {
  getVouchers({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.voucher.getVouchers(params).then(
        (response) => {
          commit("setVouchers", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  createVoucher({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.voucher.createVoucher(payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  getVoucherDetail({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      api.voucher.getVoucherDetail(id).then(
        (response) => {
          commit("setVoucherDetail", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  updateVoucher({ _ }, { id, payloads }) {
    return new Promise((resolve, reject) => {
      api.voucher.updateVoucher(id, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  deleteVoucher({ _ }, { id }) {
    return new Promise((resolve, reject) => {
      api.voucher.deleteVoucher(id).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}

const mutations = {
  setVouchers(state, value) {
    state.voucherList = value
  },
  setVoucherDetail(state, value) {
    state.voucherDetail = value
  }
}

const getters = {
  voucherList: (state) => state.voucherList,
  voucherDetail: (state) => state.voucherDetail
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
